import { TermExtension } from './TermExtension';
export class TermExtensions {
    _extensions = [];
    _modified = false;
    onChange;
    constructor(extensions = [], config // no longer supports emiRecalculationMode/Term at collection level
    ) {
        this.extensions = extensions;
        this.updateJsValues();
    }
    get modified() {
        return this._modified || this._extensions.some((e) => e.modified);
    }
    set modified(v) {
        this._modified = v;
    }
    get hasModified() {
        return this.modified;
    }
    resetModified() {
        this.modified = false;
        this._extensions.forEach((e) => (e.modified = false));
    }
    updateModelValues() {
        this._extensions.forEach((e) => e.updateModelValues());
    }
    updateJsValues() {
        this._extensions.forEach((e) => e.updateJsValues());
    }
    get extensions() {
        return this._extensions;
    }
    set extensions(vals) {
        this.modified = true;
        this._extensions = vals.map((v) => (v instanceof TermExtension ? v : new TermExtension(v)));
        if (this.onChange)
            this.onChange();
    }
    get all() {
        return this._extensions;
    }
    get active() {
        return this._extensions.filter((e) => e.active);
    }
    deactivateAll() {
        this._extensions.forEach((e) => (e.active = false));
        if (this.onChange)
            this.onChange();
    }
    activateAll() {
        this._extensions.forEach((e) => (e.active = true));
        if (this.onChange)
            this.onChange();
    }
    addExtension(ext) {
        this.modified = true;
        this._extensions.push(ext);
        if (this.onChange)
            this.onChange();
    }
    removeExtensionAtIndex(idx) {
        this.modified = true;
        this._extensions.splice(idx, 1);
        if (this.onChange)
            this.onChange();
    }
    removeAll() {
        this._extensions = [];
        if (this.onChange)
            this.onChange();
    }
    get length() {
        return this._extensions.length;
    }
    atIndex(idx) {
        return this._extensions[idx];
    }
    get first() {
        return this._extensions[0];
    }
    get last() {
        return this._extensions[this._extensions.length - 1];
    }
    getTotalActiveExtensionQuantity() {
        return this.active.reduce((sum, ext) => sum + ext.quantity, 0);
    }
    get json() {
        return this._extensions.map((e) => e.json);
    }
    toJSON() {
        return this.json;
    }
    /**
     * Returns the first active extension with EMI recalculation enabled (mode !== 'none'), or undefined.
     */
    get nextEmiRecalculationExtension() {
        return this.active.find((e) => e.emiRecalculationMode && e.emiRecalculationMode !== 'none');
    }
}
